import { render, staticRenderFns } from "./RowLabel.vue?vue&type=template&id=0f512760"
import script from "./RowLabel.vue?vue&type=script&lang=js"
export * from "./RowLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports